import api from "./api";
import { ENDPOINTS } from "./endPoints";

export interface IMarca {
  id: number;
  nome: string;
  slug: string;
  ativo: boolean;
  createAt?: string;
  updatedAt?: string;
}

export async function listarMarcas(): Promise<{ data: IMarca[] }> {
  const { url, method } = ENDPOINTS.LOJA.MARCAS.LISTAR;
  const { data } = await api({ url, method });
  return { data: data?.data ?? data ?? [] };
}

export async function criarMarca(payload: { nome: string; slug?: string; ativo?: boolean }): Promise<IMarca> {
  const { url, method } = ENDPOINTS.LOJA.MARCAS.CRIAR;
  const { data } = await api({ url, method, data: payload });
  return data;
}

export async function atualizarMarca(id: number, payload: Partial<{ nome: string; slug: string; ativo: boolean }>): Promise<IMarca> {
  const { url, method } = ENDPOINTS.LOJA.MARCAS.ATUALIZAR;
  const { data } = await api({ url: url(id), method, data: payload });
  return data;
}

export async function deletarMarca(id: number): Promise<void> {
  const { url, method } = ENDPOINTS.LOJA.MARCAS.DELETAR;
  await api({ url: url(id), method });
}
